import { Endpoints } from '@/api/ApiEndpoints';
import router from '@/router';
import { Inputs,validationSchema } from '@/entities/TextConstant/TextConstantFormInputs'

const TextConstant = {
	Plural: 'TextConstants',
	Single: 'TextConstant',
	Inputs: Inputs,	
	Relationships: [
		
	],
	ValidationSchema: validationSchema,
	SaveCallBack: (id) =>{ 
		//router.push(`/leagues/edit/${id}`)
	}
};

export default TextConstant;
